export const PHONE_DISPLAY = "(754) 666-0682";
export const PHONE_TEL = "tel:+17546660682";
export const EMAIL_DISPLAY = "michael@atlanticcorridorpm.com";

export const IMAGES = {
  heroCraftsman:
    "https://images.unsplash.com/photo-1544164560-adac3045edb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxoYW5keW1hbiUyMGNyYWZ0c21hbiUyMGhvbWUlMjByZXBhaXIlMjBjYXJwZW50cnl8ZW58MHx8fHwxNzg4Mjc0Mjg3fDA&ixlib=rb-4.1.0&q=85",
  coastalHome:
    "https://images.unsplash.com/photo-1786253940351-e8b7c36b9eaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjb2FzdGFsJTIwZmxvcmlkYSUyMG1vZGVybiUyMGhvbWUlMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODgyNzQyODd8MA&ixlib=rb-4.1.0&q=85",
  precisionTools:
    "https://images.unsplash.com/photo-1584677191047-38f48d0db64e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxoYW5keW1hbiUyMGNyYWZ0c21hbiUyMGhvbWUlMjByZXBhaXIlMjBjYXJwZW50cnl8ZW58MHx8fHwxNzg4Mjc0Mjg3fDA&ixlib=rb-4.1.0&q=85",
  patioWash:
    "https://images.unsplash.com/photo-1780898259326-4ad741d812bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxwcmVzc3VyZSUyMHdhc2hpbmclMjBob3VzZSUyMHBhdGlvJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzg4Mjc0Mjk1fDA&ixlib=rb-4.1.0&q=85",
};

export const GALLERY = [
  {
    id: "drywall",
    title: "Drywall Hole Repair",
    service: "Rapid-Response Repairs",
    location: "Boca Raton, FL",
    before:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/31ad9b0f36b17af15449f1dca93633c142dee4da7b26f514313f276a6a714125.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/d0e747dce1667cae6e93caa76ab3013d55a37c6e425476249b6852804f15d4b5.jpeg",
  },
  {
    id: "deck",
    title: "Full Deck Restoration",
    service: "Project Work & Carpentry",
    location: "Deerfield Beach, FL",
    before:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/388e06f70398a9772ff952c1aa65d469d1301fbcfc531d7b7b484525dfd05bae.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/ec81bd2e1bb61b176828aa0c606ec377e62df8d0d928c52ec121bb21b906b76b.jpeg",
  },
  {
    id: "patio",
    title: "Driveway & Patio Pressure Wash",
    service: "Project Work & Carpentry",
    location: "Fort Lauderdale, FL",
    before:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/ac830bf04d299fdc345c7b36d1fd03746f239b8786ef254ac3658ee039062964.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/d0b5d275-c3f2-441f-a838-2eec000c5306/images/0eda269c1a3b56aac60eac9101aa72c5d47c744fea02ab7e25a52352e2d8334b.jpeg",
  },
];

export const SERVICES = [
  {
    number: "01",
    title: "Rapid-Response Repairs",
    tagline: "Same-day & next-day small jobs, solved efficiently.",
    items: [
      "Drywall patch & texture match",
      "Caulking & silicone sealing",
      "Fixture & faucet swaps",
      "Door hardware & locksets",
      "Honey-do list sprint (3–6 task bundling)",
    ],
  },
  {
    number: "02",
    title: "Project Work & Carpentry",
    tagline: "Multi-day craftsmanship & restoration.",
    items: [
      "Custom deck & fence repairs",
      "Interior trim & baseboard carpentry",
      "Paint touch-up & accent walls",
      "Exterior pressure washing & patio revival",
      "Cabinet door realignments",
    ],
  },
  {
    number: "03",
    title: "Recurring Maintenance & Turnovers",
    tagline: "Proactive property protection for landlords & managers.",
    items: [
      "Scheduled quarterly inspection & upkeep",
      "Seasonal storm prep & shutter check",
      "Tenant turnover readiness packages",
      "Filter & smoke detector replacement cycles",
    ],
  },
];

export const ESTIMATOR = {
  sizes: [
    { id: "small", label: "Small Job", desc: "1–2 quick tasks · under ~2 hrs" },
    { id: "medium", label: "Half-Day", desc: "3–6 tasks or one bigger fix" },
    { id: "large", label: "Full Day+", desc: "Project work · may span days" },
  ],
  services: [
    {
      title: "Rapid-Response Repairs",
      ranges: {
        small: { low: 125, high: 250, example: "Drywall patch + faucet swap" },
        medium: { low: 275, high: 550, example: "Honey-do sprint: 4–6 bundled tasks" },
        large: { low: 600, high: 1100, example: "Whole-home fix-up day with materials" },
      },
    },
    {
      title: "Project Work & Carpentry",
      ranges: {
        small: { low: 200, high: 450, example: "Trim repair or accent-wall touch-up" },
        medium: { low: 500, high: 1200, example: "Deck board replacement + pressure wash" },
        large: { low: 1400, high: 4500, example: "Multi-day fence or deck restoration" },
      },
    },
    {
      title: "Recurring Maintenance & Turnovers",
      ranges: {
        small: { low: 150, high: 300, example: "Quarterly inspection & upkeep visit" },
        medium: { low: 350, high: 700, example: "Storm prep + filter/detector cycle" },
        large: { low: 750, high: 1500, example: "Full tenant turnover readiness package" },
      },
    },
  ],
};

export const PILLARS = [
  {
    icon: "ShieldCheck",
    title: "100% Insured & Bonded",
    desc: "Full general liability coverage for complete peace of mind on every jobsite.",
  },
  {
    icon: "FileText",
    title: "Clear Written Scopes",
    desc: "A transparent itemized estimate — materials and labor broken down before work begins.",
  },
  {
    icon: "Camera",
    title: "Photo Documentation",
    desc: "Before, during, and after photos sent straight to your phone or inbox.",
  },
  {
    icon: "Clock",
    title: "Confirmed Arrival Windows",
    desc: "Precise scheduling with a 30-minute text notification when Michael is en route.",
  },
  {
    icon: "UserCheck",
    title: "Licensed Trade Network",
    desc: "For permit-required electrical or plumbing, seamless referral to verified licensed masters.",
  },
];

export const COUNTIES = [
  {
    id: "broward",
    name: "Broward County",
    cities: ["Deerfield Beach", "Hollywood", "Fort Lauderdale", "Pompano Beach"],
    badge: "Primary Dispatch Base",
    response: "Same-day dispatch",
  },
  {
    id: "palm-beach",
    name: "Palm Beach County",
    cities: ["Boca Raton", "Delray Beach", "Boynton Beach", "West Palm Beach"],
    badge: "Same-Day Zone",
    response: "Same-day dispatch",
  },
  {
    id: "martin",
    name: "Martin County",
    cities: ["Stuart", "Hobe Sound", "Palm City"],
    badge: "Next-Day Zone",
    response: "Next-day scheduling",
  },
  {
    id: "st-lucie",
    name: "St. Lucie County",
    cities: ["Port St. Lucie", "Fort Pierce"],
    badge: "Scheduled Zone",
    response: "Confirmed windows",
  },
  {
    id: "indian-river",
    name: "Indian River County",
    cities: ["Vero Beach", "Sebastian"],
    badge: "Scheduled Zone",
    response: "Confirmed windows",
  },
  {
    id: "brevard",
    name: "Brevard County",
    cities: ["Cocoa Beach", "Melbourne", "Palm Bay"],
    badge: "Scheduled Zone",
    response: "Confirmed windows",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Michael completed our honey-do list of 7 items in a single afternoon. Clean, fast, and documented everything for our records.",
    author: "David M.",
    role: "Homeowner, Boca Raton, FL",
  },
  {
    quote:
      "As an out-of-state landlord, having Michael handle our turnover repairs with clear photos and instant updates is worth its weight in gold.",
    author: "Sarah Jenkins",
    role: "Property Manager, Fort Lauderdale, FL",
  },
  {
    quote:
      "Replaced our rotting deck boards and pressure washed the patio. Fair pricing, immaculate cleanup, and arrived exactly on time.",
    author: "Robert Vance",
    role: "Homeowner, Deerfield Beach, FL",
  },
];

export const FAQS = [
  {
    q: "What areas do you cover?",
    a: "Atlantic Corridor Property Maintenance serves the entire South Florida coastal strip from Hollywood up to Cocoa Beach, including Broward, Palm Beach, Martin, St. Lucie, Indian River, and Brevard counties.",
  },
  {
    q: "Is ACPM insured?",
    a: "Yes. Michael Caso and ACPM LLC maintain full general liability insurance. Proof of coverage is gladly provided upon request before starting any job.",
  },
  {
    q: "How quickly can you start my repair?",
    a: "For small urgent repairs in Broward and Palm Beach counties, same-day or next-day dispatch is frequently available. Larger project work is scheduled with confirmed arrival windows.",
  },
  {
    q: "Do you handle licensed plumbing or electrical work?",
    a: "We handle minor fixture swaps, hardware, and routine non-permit replacements. For work requiring heavy permits or master trade licenses, we partner with and refer trusted licensed specialists.",
  },
  {
    q: "How does pricing work?",
    a: "Every job begins with a written scope and transparent pricing — flat-rate for standard jobs or an itemized estimate for projects. No surprise add-ons.",
  },
];

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "operate", label: "How I Operate" },
  { id: "service-area", label: "Service Area" },
  { id: "work", label: "Recent Work" },
  { id: "testimonials", label: "Testimonials" },
  { id: "faq", label: "FAQ" },
  { id: "estimator", label: "Estimator" },
];
